<template>
  <div
    :class="`koc-input-${type}`"
    class="koc-partial koc-form-input-partial"
  >
    <template v-if="'textarea' === type">
      <div class="grow-wrap">
        <textarea
          :id="name"
          v-model="state.value"
          :autocomplete="autocomplete"
          :class="{ invalid: error }"
          :name="name"
          :placeholder="label"
          :readonly="readonly"
          :type="type"
          class="koc-input"
          @input="$event.target.parentNode.dataset.replicatedValue = $event.target.value"
          @keyup="validate(name, $event)"
          @change="validate(name)"
        />
        <label
          :for="name"
          class="koc-label"
        >{{ label }}</label>
      </div>
    </template>
    <template v-else>
      <input
        :id="name"
        v-model="state.value"
        :autocomplete="autocomplete"
        :class="{ invalid: error }"
        :name="name"
        :placeholder="placeholder || label"
        :readonly="readonly"
        :type="type"
        class="koc-input"
        @input="$emit(&quot;input&quot;, state.value)"
        @keyup="validate(name, $event)"
        @change="validate(name)"
      >
      <label
        :for="name"
        class="koc-label"
      >{{ label }}</label>
    </template>

    <span
      v-if="state.maxLength"
      :class="lengthClass()"
    >
      <template v-if="state.value">{{ state.maxLength - (state.value.length || 0) }}</template>
      <template v-else>{{ state.maxLength }}</template>
      characters remaining
    </span>

    <template v-if="success">
      <div class="koc-box" />
      <span class="koc-success">{{ success }}</span>
    </template>
    <template v-if="error">
      <span class="koc-error">{{ error }}</span>
    </template>
  </div>
</template>

<script src="./form-input.js"></script>
<style lang="scss" scoped src="./form-input.scss"></style>
